import attributeKeys from "../../hooks/api/attributes/attributeKeys";
import sortByProperty from "../Utilities/sortByProperty";

/**
 * Add new attributes to the attribute cache store
 * @param {Object} params
 * @param {QueryClient} params.queryClient - query client object
 * @param {Object} params.attribute - new attributes
 */
const addToAttributesStore = ({ queryClient, attributes = [] }) => {
  const queryKey = attributeKeys.attributes;

  const attributesCache = queryClient.getQueryData(queryKey);

  // Check if attribute already exists in the cache.
  const foundAttribute = attributesCache?.find(
    (currentCache) => attributes?.id === currentCache?.id
  );

  if (foundAttribute) {
    return;
  }

  queryClient.setQueryData(queryKey, (current) => {
    const updatedArray = [...attributes, ...current];
    const sortedArray =
      updatedArray?.length > 0 ? sortByProperty(updatedArray, "detail") : [];
    return sortedArray;
  });
};

export default addToAttributesStore;
